import { useState, useRef, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import {
  apiStudentStudys,
  API_SUBJECTS,
  apiChatHistoryFilterBanking,
  API_MEDIUM_TNPSC,
  API_PARTS_TNPSC,
  API_AVATAR_START,
  API_AVATAR_STOP,
  API_AVATAR_TNPSC_ASK,
  API_UNIT_TN,
  API_LESSON_TN,
  API_CHPATER_TN,
  API_MCQ_TN,
  API_BANKING_EXAMS,
  API_BANKING_SECTIONS,
  API_BANKING_SUBJECTS,
  API_BANKING_CHAPTERS,
  API_BANKING_ASK,
  API_AVATAR_BANKING_ASK
} from "../../utils/api-routes";
import { useSingleton } from "../../hooks/use-singleton";
import { useNotify } from "../../hooks/use-notify";

const useHandler = () => {
  const { get, post } = useApi();
  const { toggleNotify } = useNotify();
  const { mail, user, role, medium } = useSingleton();
  const [inputText, setInputText] = useState("");
  const [conversation, setConversation] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEnable, setIsEnable] = useState(false);
  const [mode, setMode] = useState(false);
  const [avatarSession, setAvatarSession] = useState(null);
  const [avatarToast, setAvatarToast] = useState(null);
  const [isLiveAvatarLoading, setIsLiveAvatarLoading] = useState(false);
  const [isHistoryEmpty, setIsHistoryEmpty] = useState(false);

  const [selectedMedium, setSelectedMedium] = useState("");
  const [selectedPart, setSelectedPart] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedLesson, setSelectedLesson] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const mediumRef = useRef(null);
  const partRef = useRef(null);
  const unitRef = useRef(null);
  const lessonRef = useRef(null);
  const subjectRef = useRef(null);
  const chapterRef = useRef(null);
  const languageRef = useRef(null);

  const [classdetails, setClassDetails] = useState({});
  const [mediums, setMediums] = useState([]);
  const [exams, setExams] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);

  const isStartEnabled =
    // !!selectedMedium &&
    selectedChapter.length > 0 &&
    !!selectedLanguage &&
    selectedSubject.length > 0 &&
    !!selectedPart &&
    !!selectedUnit;

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleSend = async (text) => {
    const question = (typeof text === "string" ? text : inputText).trim();
    if (!question) return;

    // Add user message
    const userMessage = { sender: "user", text: question };
    setConversation((prev) => [...prev, userMessage]);

    // Clear input box
    setInputText("");

    setIsLoading(true);

    // 2️⃣ Add temporary loading bot message
    setConversation((prev) => [
      ...prev,
      { sender: "bot", text: "Loading...", isLoading: true },
    ]);

    try {
      const payload = {
        mail: mail,
        // board: classdetails?.data?.board,
        // clas: classdetails?.data?.class,
        // subject: selectedSubject,
        exam: selectedPart,
        medium: medium,
        section: selectedUnit,
        subject: selectedSubject,
        chapter: selectedChapter.join(", "),
        question: question, // Fixed state desync bug
        language: selectedLanguage,
      };

      if (mode) {
        // --- LIVE AVATAR INTERACTION ---
        const response = await post(API_AVATAR_BANKING_ASK, payload, {
          headers: {
            "x-user-mail": mail || user?.data?.email || "",
          },
        });

        if (response.status !== 200 && response.status !== 201) {
          throw new Error(`Avatar Ask TNPSC failed: ${response.status}`);
        }

        // Drop the loading bubble, Avatar will respond audibly
        setConversation((prev) => prev.filter((msg) => !msg.isLoading));
      } else {
        // --- STANDARD TEXT CHATBOT ---
        const response = await post(API_BANKING_ASK, payload);

        setConversation((prev) =>
          prev.map((msg) =>
            msg.isLoading
              ? {
                  sender: "bot",
                  text:
                    response?.data?.answer ||
                    "Sorry, I couldn't understand that.",
                  audioPath: response?.data?.audio_path || null,
                }
              : msg,
          ),
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      setConversation((prev) =>
        prev.map((msg) =>
          msg.isLoading
            ? {
                sender: "bot",
                text: "Sorry, there was an error processing your request.",
              }
            : msg,
        ),
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        partRef.current?.contains(e.target) ||
        unitRef.current?.contains(e.target) ||
        lessonRef.current?.contains(e.target) ||
        mediumRef.current?.contains(e.target) ||
        subjectRef.current?.contains(e.target) ||
        chapterRef.current?.contains(e.target) ||
        languageRef.current?.contains(e.target)
      )
        return;

      setOpenDropdown(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res) {
        // console.log(res?.data)
        setClassDetails(res?.data);
        const payload = {
          board: res?.data?.data?.board,
          clas: res?.data?.data?.class,
        };
        getMediumDetails(payload);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      console.log("Error on getting user studiesdetails", e);
    }
  };

  const getMediumDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MEDIUM_TNPSC, payload);
      if (res) {
        setMediums(res?.data?.mediums);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getExamDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_BANKING_EXAMS, payload);
      if (res) {
        setExams(res?.data?.exams);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getSectionDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_BANKING_SECTIONS, payload);
      if (res) {
        setSections(res?.data?.sections);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  // const getLessonsDetails = async (payload) => {
  //   setIsLoading(true);
  //   try {
  //     const res = await post(API_LESSON_TN, payload);
  //     if (res) {
  //       setLessons(res?.data?.lessons);
  //       setIsLoading(false);
  //     } else {
  //       alert(res?.message);
  //     }
  //   } catch (e) {
  //     setIsLoading(false);
  //     console.log("Error on getting Subject Details", e);
  //   }
  // };

  const getSubjectDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_BANKING_SUBJECTS, payload);
      if (res) {
        setSubjects(res?.data?.subjects);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getChapterDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_BANKING_CHAPTERS, payload);
      if (res) {
        setChapters(res?.data?.chapters);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting chapeter details", e);
    }
  };

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  useEffect(() => {
    if (!medium || !classdetails?.data?.class) return;
    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      medium: medium,
    };

    getExamDetails(payload);
  }, [medium, user, classdetails?.data?.class]);

  useEffect(() => {
    if (!selectedPart || !classdetails?.data?.class) return;
    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      medium: medium,
      exam: selectedPart,
    };

    getSectionDetails(payload);
  }, [selectedPart]);

  useEffect(() => {
    if (!selectedUnit || !classdetails?.data?.class) return;
    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      exam: selectedPart,
      medium: medium,
      section: selectedUnit,
    };

    getSubjectDetails(payload);
  }, [selectedUnit]);

  useEffect(() => {
    if (!selectedSubject || !classdetails?.data?.class) return;

    const payload = {
      board: classdetails?.data?.board,
      clas: classdetails?.data?.class,
      exam: selectedPart,
      medium: medium,
      section: selectedUnit,
      subject: selectedSubject,
    };
    getChapterDetails(payload);
  }, [selectedSubject]);

  useEffect(() => {
    if (!isEnable) {
      setConversation([]);
    }
  }, [selectedSubject, selectedChapter, selectedLanguage]);

  const onClickStart = () => {
    setConversation([]);
    setIsEnable(true);
    setIsHistoryEmpty(false);
  };

  const getHistoryDetails = async () => {
    try {
      const res = await get(
        apiChatHistoryFilterBanking(
          mail,
          classdetails?.data?.board,
          classdetails?.data?.class,
          medium,
          selectedPart,
          selectedUnit,
          selectedChapter.join(", "),
          selectedSubject,
          selectedLanguage,
          classdetails?.data?.class,
        ),
      );
      if (res?.data?.history.length) {
        const formattedConversation = [];

        res?.data?.history?.forEach((item) => {
          // user message
          formattedConversation.push({
            sender: "user",
            text: item.user_question,
            time: item.created_at,
          });

          // bot message
          formattedConversation.push({
            sender: "bot",
            text: item?.ai_answer,
            audioPath: item?.audio_path || null,
          });
        });

        setConversation(formattedConversation);
        setIsHistoryEmpty(false);
      } else {
        setIsHistoryEmpty(true);
      }
    } catch (e) {
      console.log("ERROR IS COMES FROM GETHISTORY API", e);
    }
  };

  const onClickHistroy = async () => {
    if (isStartEnabled) {
      await getHistoryDetails();
      setIsEnable(true);
    }
  };

  const onToggleBtn = () => {
    if (role !== "guest") {
      setMode((p) => !p);
      setConversation([]);
      setIsEnable(false);
      setAvatarSession(null);
    } else {
      toggleNotify({
        type: "success",
        title: "Message",
        description: "Please Subscribe",
      });
    }
  };

  const onLiveAvatarApi = async () => {
    setIsEnable(true);
    setIsLiveAvatarLoading(true);

    setConversation([
      { sender: "bot", text: "Connecting to Live Avatar...", isLoading: true },
    ]);

    try {
      const response = await post(
        `${API_AVATAR_START}?language=${selectedLanguage}`,
        {},
        {
          headers: {
            "x-user-mail": mail || user?.data?.email || "",
          },
        },
      );

      console.log("AVATAR API STATUS:", response.status);
      const data = response.data;
      console.log("AVATAR START RESPONSE:", data);

      if (response.status === 200 || response.status === 201) {
        setAvatarSession(data || { connected: true });
        setIsLiveAvatarLoading(false);
        setConversation([
          {
            sender: "bot",
            text: "Live Avatar connected successfully! You can now start interacting.",
          },
        ]);
      } else {
        throw new Error(data?.message || `Error: ${response.status}`);
      }
    } catch (err) {
      console.error("Error starting Avatar API:", err);
      setIsEnable(false);
      const msg = err?.message || "Unable to connect to Live Avatar.";
      setAvatarToast({
        type: "error",
        message:
          msg.includes("502") || msg.includes("403")
            ? "Unable to connect: Avatar service unavailable."
            : msg,
      });
      setTimeout(() => setAvatarToast(null), 4000);
      setConversation([]);
    } finally {
      setIsLiveAvatarLoading(false);
    }
  };

  const onEndAvatarInteraction = async () => {
    setConversation([]);
    setIsEnable(false);
    setAvatarSession(null);
    try {
      const response = await post(
        API_AVATAR_STOP,
        {},
        {
          headers: {
            "x-user-mail": mail || user?.data?.email || "",
          },
        },
      );
      console.log("AVATAR STOP RESPONSE STATUS:", response.status);
    } catch (err) {
      console.error("Error stopping Avatar API:", err);
    }
  };

  const handleClearChat = () => {
    setConversation([]); // clear messages only
  };

  const handleNewChat = () => {
    // clear chat
    setConversation([]);

    // reset filters
    setSelectedSubject(null);
    setSelectedChapter([]);
    setSelectedLanguage(null);
    setSelectedPart(null);
    setSelectedUnit(null);
    setSelectedLesson([]);

    // reset input
    setInputText("");
    setOpenDropdown(null);

    // ✅ IMPORTANT
    setIsEnable(false); // 👈 this will hide input section

    // optional resets
    setIsHistoryEmpty(false);
    onEndAvatarInteraction?.();
  };

  return {
    handleClearChat,
    handleNewChat,
    subjectRef,
    chapterRef,
    languageRef,
    conversation,
    selectedChapter,
    selectedLanguage,
    selectedSubject,
    openDropdown,
    inputText,
    classdetails,
    subjects,
    chapters,
    isLoading,
    user,
    isStartEnabled,
    isEnable,
    mode,
    avatarSession,
    avatarToast,
    selectedMedium,
    selectedLesson,
    selectedPart,
    selectedUnit,
    mediums,
    exams,
    sections,
    mediumRef,
    partRef,
    lessonRef,
    unitRef,
    isHistoryEmpty,
    onToggleBtn,
    onClickHistroy,
    onClickStart,
    setSelectedSubject,
    setSelectedChapter,
    setSelectedLanguage,
    setOpenDropdown,
    setInputText,
    setSelectedLesson,
    setSelectedPart,
    setSelectedUnit,
    handleSend,
    handleKeyPress,
    getHistoryDetails,
    onLiveAvatarApi,
    onEndAvatarInteraction,
    setSelectedMedium,
    isLiveAvatarLoading,
  };
};

export default useHandler;
